module.exports = __webpack_public_path__ + "img/toes.eca3cf1c.png";